module.exports = __webpack_public_path__ + "media/images/icons/paper-4b2e3f7acb82c1d824bcf772761d28a7.svg";